import request from '@/utils/request'

// 用户相关 API
export const userApi = {
    // 登录
    login(data) {
        return request.post('/login', data)
    },

    // 注册
    register(data) {
        return request.post('/register', data)
    },
    //获取验证码
    getCaptcha() {
        return request.get('/captchaImage')
    },

    // 获取用户信息
    getUserInfo() {
        return request.get('/getInfo')
    },

    // 退出登录
    logout() {
        return request.post('/api/user/logout')
    },
    // 网页端查询首页信息-无需登录
    getWbdIndex() {
        return request.get('/system/index/wbdIndex')
    },
}
export const indexApi = {
    // 底部配置列表
    getIndex() {
        return request.get('/system/low/lowList')
    },
    // 查询whois信息
    getWhois(name) {
        return request.get('/system/names/whois/' + name)
    },
}

// 查询域名商城列表
export const productApi = {
    // 获取商品列表
    getYmList(params) {
        return request.get('/system/names/list', params)
    },

    // 获取商品详情
    getProductDetail(id) {
        return request.get(`/api/products/${id}`)
    },

    // 创建商品
    createProduct(data) {
        return request.post('/api/products', data)
    },

    // 更新商品
    updateProduct(id, data) {
        return request.put(`/api/products/${id}`, data)
    },

    // 删除商品
    deleteProduct(id) {
        return request.delete(`/api/products/${id}`)
    }
}
// 新闻资讯相关 API
export const newsApi = {
    //  获取新闻列表
    getNewsList(params) {
        return request.get('/system/news/list', params)
    },


}

// 文件上传
export const uploadApi = {
    uploadFile(file) {
        return request.upload('/api/upload', file)
    }
}

// 导出所有 API
export default {
    userApi,
    productApi,
    uploadApi,
    newsApi,
    indexApi
}